module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "Music",
		"url": "/category/music",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music/miscellaneous"
			}
		]
	},
	{
		"name": "Music Packs",
		"url": "/category/music-packs",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music-packs",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music-packs/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music-packs/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music-packs/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music-packs/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music-packs/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music-packs/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music-packs/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music-packs/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music-packs/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music-packs/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music-packs/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music-packs/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music-packs/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music-packs/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music-packs/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music-packs/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music-packs/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music-packs/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music-packs/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music-packs/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music-packs/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music-packs/miscellaneous"
			}
		]
	},
	{
		"name": "Music Kits",
		"url": "/category/music-kits",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music-kits",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music-kits/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music-kits/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music-kits/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music-kits/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music-kits/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music-kits/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music-kits/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music-kits/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music-kits/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music-kits/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music-kits/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music-kits/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music-kits/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music-kits/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music-kits/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music-kits/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music-kits/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music-kits/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music-kits/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music-kits/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music-kits/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music-kits/miscellaneous"
			}
		],
		"isNew": true
	},
	{
		"name": "Logos & Idents",
		"url": "/category/logos-idents",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=logos-idents",
				"isTop": true
			},
			{
				"name": "Individual",
				"url": "/category/logos-idents/individual"
			},
			{
				"name": "Packs",
				"url": "/category/logos-idents/packs"
			}
		]
	},
	{
		"name": "Sound Effects",
		"url": "/category/sound",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=sound",
				"isTop": true
			},
			{
				"name": "Buttons & Menus",
				"url": "/category/sound/buttons-menus"
			},
			{
				"name": "Cartoon Sounds",
				"url": "/category/sound/cartoon-sounds"
			},
			{
				"name": "Domestic Sounds",
				"url": "/category/sound/domestic-sounds"
			},
			{
				"name": "Futuristic Sounds",
				"url": "/category/sound/futuristic-sounds"
			},
			{
				"name": "Game Sounds",
				"url": "/category/sound/game-sounds"
			},
			{
				"name": "Human Sounds",
				"url": "/category/sound/human-sounds"
			},
			{
				"name": "Industrial Sounds",
				"url": "/category/sound/industrial-sounds"
			},
			{
				"name": "Interface Sounds",
				"url": "/category/sound/interface-sounds"
			},
			{
				"name": "Nature Sounds",
				"url": "/category/sound/nature-sounds"
			},
			{
				"name": "Sound",
				"url": "/category/sound/sound"
			},
			{
				"name": "Sound Packs",
				"url": "/category/sound/sound-packs"
			},
			{
				"name": "Transitions & Movement",
				"url": "/category/sound/transitions-movement"
			},
			{
				"name": "Urban Sounds",
				"url": "/category/sound/urban-sounds"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/sound/miscellaneous"
			}
		]
	},
	{
		"name": "Source Files",
		"url": "/category/source-files",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=source-files",
				"isTop": true
			},
			{
				"name": "Cubase",
				"url": "/category/source-files/cubase"
			},
			{
				"name": "FL Studio",
				"url": "/category/source-files/fl-studio"
			},
			{
				"name": "Logic Pro",
				"url": "/category/source-files/logic-pro"
			},
			{
				"name": "Reason",
				"url": "/category/source-files/reason"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/source-files/miscellaneous"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/audiojungle.json
// module id = 479
// module chunks = 1